import React, { useContext, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { FormGroup } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import { DataContext } from "../../Context/Context";
import Modal from "@material-ui/core/Modal";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import NativeSelect from "@material-ui/core/NativeSelect";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { IconPicker } from "react-fa-icon-picker";
import { IconPickerItem } from "react-fa-icon-picker";
import Navbar from "../Navbar";
import NavbarBottom from "../NavbarBottom";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    "& > *": {
      marginTop: theme.spacing(5),
      width: theme.spacing(50),
    },
    marginTop: 60,
  },
  title: {
    fontSize: 15,
    textAlign: "left",
    margin: 0,
    color: "grey",
    fontWeight: 600,
    padding: "10px 10px",
    backgroundColor: "rgb(240, 238, 238)",
  },
  addNewBtnWrapper: {
    position: "relative",
  },
  addNewBtn: {
    lineHeight: 0,
    marginTop: 25,
    position: "absolute",
    left: 34,
  },
  addNewBtnLeft: {
    fontSize: 40,
    marginRight: 2,
  },
  addNewBtnRight: {
    textTransform: "capitalize",
    marginLeft: 18,
  },
  categoriesWrapper: {
    width: "80%",
    margin: "70px auto",
    paddingLeft: 0,
  },
  categories: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: 15,
    borderBottom: "1px solid lightgrey",
    cursor: "pointer",
  },
  name: {
    margin: "0 0 0 20px",
  },
  nameIconWrapper: {
    display: "flex",
  },
  budget: {
    fontSize: 18,
  },
  expenseColor: {
    color: "#b30a2e",
  },
  incomeColor: {
    color: "#088d80",
  },
  disableColor: {
    color: "grey",
  },
  paper: {
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
    width: 300,
    height: 460,
    backgroundColor: theme.palette.background.paper,
    border: "1px solid lightgrey",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  noBudgetLimit: {
    width: "12%",
    fontSize: 9,
    textTransform: "uppercase",
    color: "grey",
  },
  modal: {
    backgroundColor: "rgba(0, 0, 0, 0.1)",
  },
  modalTitle: {
    marginTop: 0,
  },
  select: {
    padding: "18.5px 14px",
    border: "1px solid lightgrey",
    borderRadius: "4px",
    marginLeft: 0,
    marginBottom: 30,
    width: "100%",
    color: "#a2a2a2",
    height: "1.1876em",
  },
  option: {
    color: "grey",
  },
  inputName: {
    marginLeft: 0,
    marginBottom: 30,
  },
  formControl: {
    minWidth: 120,
  },
  inputBudget: {
    marginBottom: 30,
  },
  modalEnableCheck: {
    padding: "12px 14px",
    border: "1px solid lightgrey",
    borderRadius: "4px",
    margin: 0,
    color: "#a2a2a2",
    height: "1.1876em",
  },
  modalAddUpdateBtn: {
    color: "white",
    backgroundColor: "#6200ee",
    fontWeight: "bold",
    "&:hover": {
      backgroundColor: "#6200ee",
    },
  },
  modalCancelBtn: {
    color: "#6200ee",
    textTransform: "uppercase",
    fontWeight: "bold",
  },
  modalBtns: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: 50,
  },
  iconPicker: {
    width: "200px",
  },
}));

export default function Categories() {
  const classes = useStyles();

  const { wizardCategories, setWizardCategories } = useContext(DataContext);

  const [open, setOpen] = useState(false);
  const [updateItem, setUpdateItem] = useState(false);

  const [addNewItem, setAddNewItem] = useState({
    id: new Date().valueOf(),
    type: "Income",
    name: "",
    icon: "FaRegHeart",
    budget: "",
    isEnabled: true,
  });

  const handleSubmit = (e) => {
    e.preventDefault();

    if (updateItem !== false) {
      let tempWizardCategories = wizardCategories;
      tempWizardCategories[updateItem] = addNewItem;

      localStorage.setItem("categories", JSON.stringify(tempWizardCategories));
      setWizardCategories(tempWizardCategories);

      setUpdateItem(false);
    } else {
      localStorage.setItem(
        "categories",
        JSON.stringify([...wizardCategories, addNewItem])
      );
      setWizardCategories([...wizardCategories, addNewItem]);

      setAddNewItem({
        id: new Date().valueOf(),
        type: "Income",
        name: "",
        icon: "FaRegHeart",
        budget: "",
        isEnabled: true,
      });
    }
    handleClose();
  };

  const handleClose = () => {
    setOpen(false);

    setUpdateItem(false);

    setAddNewItem({
      id: new Date().valueOf(),
      type: "Income",
      name: "",
      icon: "FaRegHeart",
      budget: "",
      isEnabled: true,
    });
  };

  const handleUpdate = (editingItem, index) => {
    setOpen(true);

    setUpdateItem(index);

    setAddNewItem({
      id: editingItem.id,
      type: editingItem.type,
      name: editingItem.name,
      icon: editingItem.icon,
      budget: editingItem.budget,
      isEnabled: editingItem.isEnabled,
    });
  };

  const handleAddNew = () => {
    setOpen(true);
  };

  const body = (
    <form className={classes.paper} onSubmit={(e) => handleSubmit(e)}>
      <p className={classes.modalTitle} id="simple-modal-title">
        {`${updateItem !== false ? "Update" : "Add new"} category`}
      </p>
      <FormGroup id="simple-modal-description">
        <FormControl variant="outlined" className={classes.formControl}>
          <NativeSelect
            value={addNewItem.type || "Income"}
            onChange={(e) =>
              setAddNewItem({ ...addNewItem, type: e.target.value })
            }
            className={classes.select}
            required
          >
            <option className={classes.option} value={"Income"}>
              Income
            </option>
            <option className={classes.option} value={"Expense"}>
              Expense
            </option>
          </NativeSelect>
        </FormControl>
        <FormControl>
          <TextField
            className={classes.inputName}
            type="text"
            id="outlined-basic"
            variant="outlined"
            placeholder="Name"
            size="small"
            value={addNewItem.name || ""}
            required
            onChange={(e) =>
              setAddNewItem({ ...addNewItem, name: e.target.value })
            }
          />
        </FormControl>
        <FormControl>
          <IconPicker
            value={addNewItem.icon || "FaRegHeart"}
            onChange={(v) => setAddNewItem({ ...addNewItem, icon: v })}
          />
        </FormControl>
        <FormControl>
          <TextField
            className={classes.inputBudget}
            type="number"
            id="outlined-basic"
            variant="outlined"
            placeholder="Budget"
            size="small"
            value={addNewItem.budget || ""}
            onChange={(e) =>
              setAddNewItem({ ...addNewItem, budget: e.target.value })
            }
          />
        </FormControl>
        <FormControl>
          <FormControlLabel
            className={classes.modalEnableCheck}
            label="Enabled"
            control={
              <Checkbox
                onChange={(e) =>
                  setAddNewItem({
                    ...addNewItem,
                    isEnabled: e.target.checked,
                  })
                }
                color="default"
                checked={addNewItem.isEnabled}
              />
            }
          />
        </FormControl>
      </FormGroup>
      <div className={classes.modalBtns}>
        <Button onClick={handleClose} className={classes.modalCancelBtn}>
          Cancel
        </Button>
        <Button
          type={"submit"}
          className={classes.modalAddUpdateBtn}
          disabled={addNewItem.name === ""}
        >
          {`${updateItem !== false ? "Update" : "Add"}`}
        </Button>
      </div>
    </form>
  );

  return (
    <>
      <Navbar />
      <div className={classes.root}>
        <Paper elevation={3}>
          <h1 className={classes.title}>Categories</h1>
          <div className={classes.addNewBtnWrapper}>
            <Button className={classes.addNewBtn} onClick={handleAddNew}>
              <span className={classes.addNewBtnLeft}>+</span>
              <span className={classes.addNewBtnRight}>Add new category</span>
            </Button>
          </div>
          <ul className={classes.categoriesWrapper}>
            {wizardCategories.map((category, index) => {
              return (
                <li
                  onClick={() => handleUpdate(category, index)}
                  key={category.id}
                  className={`${classes.categories}
                  ${
                    category.type === "Expense"
                      ? classes.expenseColor
                      : classes.incomeColor
                  } ${category.isEnabled == false ? classes.disableColor : ""}`}
                >
                  <div className={classes.nameIconWrapper}>
                    <IconPickerItem color="inherit" icon={category.icon}>
                      {category.icon}
                    </IconPickerItem>
                    <p className={classes.name}>{category.name}</p>
                  </div>
                  {category.budget ? (
                    <span className={classes.budget}>{category.budget}</span>
                  ) : (
                    <span className={classes.noBudgetLimit}>
                      No budget limit
                    </span>
                  )}
                </li>
              );
            })}
          </ul>
        </Paper>
      </div>
      <Modal
        open={open}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        className={classes.modal}
      >
        {body}
      </Modal>
      <NavbarBottom />
    </>
  );
}
